<template>
  <div>
    <div id="topAnchor">
      <div class="home_header">
        <div class="Home_info">
          <h1>湃睿科技轻量化</h1>
          <span class="home_span">掌握模型轻量化与简化的核心技术;</span>
          <span class="home_span"
            >实现设计数据在产品全生命周期各个环节中的应用；</span
          >
          <span class="home_span"
            >满足工艺、制造、销售、培训、交付、运维等应用场景对设计数据的转换需求;</span
          >
          <span class="home_span"
            >参与DISA联盟《三维CAD模型轻量化格式》团体标准的制定；</span
          >
        </div>
        <img src="../../assets/img/home/home.png" width="100%" alt="" />
        <car-model></car-model>
      </div>
      <div class="home_product">
        <div class="home_title">
          <div class="home_line">
            <div><span class="home_p">产品介绍</span></div>
            <div><span class="home_p_en">Product Introduction</span></div>
            <div>
              <span class="home_p_text"
                >自主研发CAD内部插件，自动批量转换应用程序，实现多格式模型轻量化格式转换，配套可视化查看器。</span
              >
            </div>
          </div>
        </div>
        <div class="product-wrapper">
          <div class="product-container">
            <div
              class="product-card"
              v-for="(item, index) of productList"
              :key="index"
              ref="tiltContainer"
            >
              <img class="card-image" :src="getImagePath(item.image)" />
              <div class="card-content">
                <h3 class="card-title">{{ item.title }}</h3>
                <p>
                  {{ item.text }}
                </p>
                <div class="card-button" @click="seeProductDetail(item.link)">
                  <div>
                    查看详情<span class="iconfont icon-youjiantou right"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="home_solution">
        <div class="home_title">
          <div class="home_line">
            <div>
              <span class="home_p">解决方案</span>
            </div>
            <div>
              <span class="home_p_en">Product Solution</span>
            </div>
            <div class="mTop10">
              <span class="home_p_info">
                通过对模型轻量化与简化，满足工艺、制造、销售、培训、交付、运维等应用场景对设计数据的转换需求。
              </span>
            </div>
          </div>
          <div
            style="text-align: center; margin-top: 10px; margin-bottom: 50px"
          >
            <div>
              <div class="swiper">
                <div class="swiper-wrapper">
                  <div
                    class="swiper-slide"
                    v-for="(item, index) of solutionList"
                    :key="index"
                  >
                    <div
                      class="home_solution_item"
                      @click="seeSolutionDetail(item.router)"
                    >
                      <h2>{{ item.title }}</h2>
                      <span>
                        {{ item.content }}
                      </span>
                      <div>
                        <img :src="getImagePath(item.img)" class="home_solute_img" />
                      </div>
                    </div>
                  </div>
                  <div
                    class="swiper-slide solution-content"
                    v-for="item in solutionArray"
                    :key="item.id"
                  >
                    <div class="home_solution_item_no">
                      <h2>{{ item.title }}</h2>
                      <span>
                        {{ item.content }}
                      </span>
                      <div>
                        <img :src="getImagePath(item.img)" class="home_solute_img" />
                      </div>
                      <div class="pending-text">待完善</div>
                    </div>
                  </div>
                </div>
                <div class="swiper-button-prev"></div>
                <div class="swiper-button-next"></div>
                <div class="swiper-scrollbar"></div>
                <div class="swiper-mousewheel"></div>
              </div>
            </div>
          </div>
          <div style="margin-top: 50px">
            <button class="home_btn_more" @click="SolutionClik">
              了解详情<span style="color: #85afcf; font-size: 24px">++</span>
            </button>
          </div>
        </div>
        <!-- <canvas id="fire"></canvas> -->
      </div>
      <div class="home_data">
        <div class="weight-box">
          <div class="home_line">
            <div><span class="home_p">专业服务</span></div>
            <div><span class="home_p_en">Professional Services</span></div>
          </div>
          <div class="light_data">
            <div class="data_left" @click="DesignClik">
              <div class="title">转换服务</div>
              <div class="content">
                CAD多种格式转换自主格式（*.piv）模型，
                输出模型包含装配结构和几何信息、 属性、参数、PMI等原有信息。
              </div>
            </div>
            <div class="data_right">
              <el-carousel height="350px">
                <el-carousel-item>
                  <div class="data_item">
                    <img
                      src="../../assets/img/swiper/AR15.png"
                      alt=""
                      @click="goToDetail('/AR-15/asm0001.asm')"
                    />
                  </div>
                </el-carousel-item>
                <el-carousel-item>
                  <div class="data_item">
                    <img
                      src="../../assets/img/swiper/F-22.png"
                      alt=""
                      @click="
                        goToDetail('/F-22/new_version_f-22_gears_down.asm')
                      "
                    />
                  </div>
                </el-carousel-item>
                <el-carousel-item>
                  <div class="data_item">
                    <img
                      src="../../assets/img/swiper/CAR.png"
                      alt=""
                      @click="goToDetail('/my_car/my_car.asm')"
                    />
                  </div>
                </el-carousel-item>
              </el-carousel>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CarModel from "../../components/tabbar/Car.vue";
import Swiper from "swiper";
import { Navigation, Scrollbar, Mousewheel } from "swiper/modules";
import "swiper/swiper.css";
import "swiper/modules/navigation.css";
import "swiper/modules/scrollbar.css";
import "swiper/modules/mousewheel.css";
import VanillaTilt from "vanilla-tilt";
Swiper.use([Navigation, Scrollbar, Mousewheel]);
export default {
  name: "Home",
  components: {
    CarModel
  },
  data() {
    return {
      tab: 1,
      qrTexxt: "",
      currentSlideIndex: 0,
      modules: [],
      productList: [
        {
          id: 1,
          title: "CAD可视化输出插件",
          image: require("../../assets/img/swiper/T_A.webp"),
          link: "adapter",
          text:
            "集成到CAD设计软件中，支持多款CAD模型转换，可以配置控制输出精度，压缩倍数达到10-100倍，保留模型原始所有结构等信息。"
        },
        {
          id: 2,
          title: "可视化查看工具",
          image: require("../../assets/img/swiper/T_V.webp"),
          link: "viewer",
          text:
            "自主研发可视化查看工具，可款跨平台、跨浏览器、跨终端设备，与三维模型基本交互、注释、动画、渲染等，大模型加载操作流畅。"
        },
        {
          id: 3,
          title: "模型批量转换工具",
          image: require("../../assets/img/swiper/T_WGM.webp"),
          link: "wgm",
          text:
            "批量转换工具完美配合，TASK机监听模型路径自动分配任务，Worker机接收任务完成自动模格式转换型，快速完成模型格式转换"
        }
      ],
      solutionList: [
        {
          id: 1,
          title: "设计模型轻量化解决方案",
          content:
            "支持多种CAD软件模型轻量化，Creo、CATIA、NX、SolidWorks等CAD软件可视化输出；",
          img: require("../../assets/img/home/change.png"),
          router: "solution_desgin",
          isShow: true
        },
        {
          id: 2,
          title: "SaaS化模型分享解决方案",
          content:
            "用户上传模型，云服务自动转档，二维码分享查看模型，多用户扫码查看，跨终端设备查看模型；",
          img: require("../../assets/img/home/saas.png"),
          router: "solution_saas",
          isShow: true
        }
      ],
      solutionArray: [
        {
          id: 3,
          title: "产品三维展示解决方案",
          img: require("../../assets/img/home/sale.png"),
          isShow: false
        },
        {
          id: 4,
          title: "产品选型解决方案",
          img: require("../../assets/img/home/selection.png"),
          isShow: false
        },
        {
          id: 5,
          title: "三维发布物电子手册解决方案",
          img: require("../../assets/img/home/manual.png"),
          isShow: false
        },
        {
          id: 6,
          title: "工艺模型轻量化解决方案",
          img: require("../../assets/img/home/process-route.png"),
          isShow: false
        },
        {
          id: 7,
          title: "基于Web的三维装配工艺",
          img: require("../../assets/img/home/assembly.png"),
          isShow: false
        },
        {
          id: 8,
          title: "生产线加工模拟解决方案",
          img: require("../../assets/img/home/worksheet.png"),
          isShow: false
        },
        {
          id: 9,
          title: "模型比较解决方案",
          img: require("../../assets/img/home/comparison.png"),
          isShow: false
        },
        {
          id: 10,
          title: "CAE模型可视化解决方案",
          img: require("../../assets/img/home/CAE-model.png"),
          isShow: false
        },
        {
          id: 11,
          title: "ECAD模型可视化解决方案",
          img: require("../../assets/img/home/ECAD-model.png"),
          isShow: false
        },
        {
          id: 12,
          title: "产品备件解决方案",
          img: require("../../assets/img/home/spare-parts.png"),
          isShow: false
        },
        {
          id: 13,
          title: "产品服务解决方案",
          img: require("../../assets/img/home/productService.png"),
          isShow: false
        },
        {
          id: 14,
          title: "产品运维解决方案",
          img: require("../../assets/img/home/operation.png"),
          isShow: false
        },
        {
          id: 15,
          title: "供应链解决方案",
          img: require("../../assets/img/home/supply-chain.png"),
          isShow: false
        },
        {
          id: 16,
          title: "三维模型下车间解决方案",
          img: require("../../assets/img/home/workshop.png"),
          isShow: false
        },
        {
          id: 17,
          title: "虚拟培训解决方案",
          img: require("../../assets/img/home/VR.png"),
          isShow: false
        }
      ]
    };
  },
  methods: {
    tabChange: function(e) {
      let tabid = e.target.dataset.id;
      this.tab = tabid;
      if (tabid === 1 || tabid === 2 || tabid === 3) {
        this.tab = tabid;
      } else {
        this.sort = tabid;
      }
      if (tabid == 1) {
        this.imgShow = 0;
        this.leftVal = 0;
        this.leftVal = 0;
      }
      if (tabid == 2) {
        this.imgShow = 0;
        this.leftVal = 0;
        this.leftVal = 0;
      }
      if (tabid == 3) {
        this.imgShow = 0;
        this.leftVal = 0;
        this.leftVal = 0;
      }
    },
    getImagePath(imageModule) {
    return imageModule.default || imageModule;
  },
    ProductClik() {
      this.$router
        .push({
          path: "/product"
        })
        .catch((err) => err);
    },
    SolutionClik() {
      this.$router
        .push({
          path: "/Solution"
        })
        .catch((err) => err);
    },
    DesignClik() {
      this.$router
        .push({
          path: "/design"
        })
        .catch((err) => err);
    },
    seeProductDetail(value) {
      this.$router.push({
        path: "/product",
        name: "product",
        query: { view: value }
      });
    },
    seeSolutionDetail(value) {
      this.$router.push({
        path: "/Solution",
        query: { view: value }
      });
    },
    goToDetail(value) {
      let qrTexxt =
        "http://internal.pisx.com:8013/TundraViewer/dist/professional/index.html#../../Models" +
        value +
        ".piv";
      this.qrTexxt = qrTexxt;
      window.open(this.qrTexxt, "_blank");
    }
  },
  mounted() {
    new Swiper(".swiper", {
      slidesPerView: 3,
      spaceBetween: 20,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      scrollbar: {
        el: ".swiper-scrollbar"
      },
      mousewheel: true
    });
    // gsap.from(".product-card", {
    //   duration: 1,
    //   opacity: 0,
    //   y: -50,
    //   scale: 0.5,
    //   stagger: 0.3,
    //   ease: "back.in"
    // });
    VanillaTilt.init(this.$refs.tiltContainer, {
      max: 20,
      speed: 1000
    });
  },
  created: function() {
    this.$emit("FootItem", true);
  }
};
</script>

<style scoped lang="less">
.home_header {
  height: 804px;
}

.product-wrapper {
  width: 100%;
  .product-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    .product-card {
      display: flex;
      flex-direction: column;
      max-width: 500px;
      overflow: hidden;
      margin: 20px;
      background-color: #f5f5f5;
      transform-style: preserve-3d;
      transform: perspective(1000px);
      transition: box-shadow 0.3s ease-in-out;
      .card-image {
        max-width: 100%;
        height: auto;
        cursor: pointer;
        transform: translateZ(20px);
      }
      .card-content {
        display: flex;
        flex-direction: column;
        padding: 20px;
        .card-title {
          font-size: 24px;
          font-weight: bold;
          margin: 10px 0;
        }
        p {
          font-size: 16px;
          margin: 10px 0;
        }
        .card-button {
          align-self: center;
          margin-top: auto;
          background-color: #fff;
          color: #000;
          border: 1px solid #000;
          font-size: 16px;
          padding: 10px 24px;
          border-radius: 4px;
          cursor: pointer;
        }
        .card-button:hover {
          background-color: #000;
          color: #fff;
          border: 1px solid #fff;
          cursor: pointer;
        }
      }
    }
    .product-card:hover {
      box-shadow: 0 8px 16px rgba(0, 0, 0, 0.3);
    }
  }
}

.light_data {
  width: 1600px;
  display: flex;
  justify-content: space-between;
}

.data_left {
  width: 600px;
  padding: 18px 18px 0 18px;
  color: rgba(80, 80, 80, 1);
  background-color: #efefef;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 16px;
  cursor: pointer;
}

.data_left {
  .title {
    font-size: 40px;
    font-weight: bold;
    margin-bottom: 42px;
  }
}

.data_left {
  .content {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 50px;
  }
}

.weight-box {
  width: 80%;
  margin: 0 auto;
}

.data_right {
  width: 850px;
  position: relative;
  .data_item {
    img {
      width: 600px;
      height: 328px;
      cursor: pointer;
    }
  }

  ::v-deep .el-carousel__arrow--left {
    color: #00bfff;
    font-size: 48px;
    background: none;
  }
  ::v-deep .el-carousel__arrow--right {
    color: #00bfff;
    font-size: 48px;
    background: none;
  }

  .el-carousel ::v-deep .el-carousel__indicators {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .el-carousel ::v-deep .el-carousel__indicator > .el-carousel__button {
    width: 8px;
    height: 8px;
    margin: 0 4px;
    border-radius: 50%;
    cursor: pointer;
    background-color: #dcdcdc;
  }

  .el-carousel
    ::v-deep
    .el-carousel__indicator.is-active
    > .el-carousel__button {
    background-color: #00bfff;
  }
}

.swiper {
  width: 90%;
  height: 480px;
}

.home_p_text {
  font-size: 16px;
  color: #666;
}
.swiper-slide {
  font-size: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
}
.solution-content {
  background-color: #00000066;
}

.home_solution_item {
  width: 100%;
  padding: 0 20px;
  cursor: pointer;
}
.home_solution_item_no {
  width: 100%;
  padding: 0 20px;
  cursor: not-allowed;
  position: relative;

  .pending-text {
    position: absolute;
    top: -34px;
    left: 50%;
    transform: translateX(-50%);
    background-color: #000;
    color: #fff;
    padding: 4px 8px;
    border-radius: 4px;
  }
}
.swiper-scrollbar {
  background: none;
}

.right {
  margin-left: 6px;
}
</style>
